import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { routes } from 'constants/config';
import PageTitle from 'components/shared/PageTitle';
import { useFetch } from 'hooks';
import { Icon } from 'ui';
import {
  TabbedView,
  Tab,
  TabList,
  TabPanel,
} from 'components/shared/TabbedView';
import { getQueryParam } from 'utils/url';
import useFeatureFlags from 'hooks/useFeatureFlags';
import PreviousAttemptsTab from './PreviousAttempts/PreviousAttemptsTab';
import CurrentResponseTab from './CurrentResponseTab';

const tabs = {
  current_response: 0,
  previous_responses: 1,
};

const OnDemandPracticeScenario = ({ scenarioId, isPreviewing }) => {
  const queryParamTab = tabs[getQueryParam(window.location.href, 'tab')] || 0;
  const { data = {}, loading } = useFetch(
    isPreviewing
      ? routes.ON_DEMAND_PRACTICE.PREVIEW.SHOW(scenarioId)
      : routes.ON_DEMAND_PRACTICE.LEARNING.SHOW(scenarioId),
  );
  const [tabState, setTabState] = useState({
    tab: queryParamTab,
    highlightFirstAttempt: false,
    disabled: true,
  });
  useEffect(() => {
    if (data.attemptCount !== undefined) {
      setTabState(tab => ({ ...tab, disabled: data.attemptCount === 0 }));
    }
  }, [data.attemptCount]);
  const hasZiggeoForAllMedia = useFeatureFlags(['ziggeo_for_all_media']);

  if (loading) return null;

  const disableInteraction =
    !data.scenarioType === 'conversation' && isPreviewing;
  const scenarioStyles = classNames('OnDemandPracticeScenario', {
    'OnDemandPracticeScenario--disabled': disableInteraction,
  });
  return (
    <>
      <PageTitle title={t('practice.on_demand_practice.title')} />
      {data.currentUserId && isPreviewing && (
        <div className="NotificationContainer NotificationContainer--secondary mt-0">
          {t('notices.previewing_content', { content_type: 'scenario' })}
        </div>
      )}
      <div className={scenarioStyles}>
        <div className={disableInteraction ? 'pe-n' : ''}>
          <Link
            className="OnDemandPracticeScenario-backLink"
            to={routes.ON_DEMAND_PRACTICE.LEARNING.INDEX(1)}
          >
            <Icon name="back" className="mr-4" />
            {t('practice.on_demand_practice.back_link')}
          </Link>
          <TabbedView
            selectedIndex={tabState.tab}
            onSelect={tab => setTabState({ tab, highlightFirstAttempt: false })}
          >
            <TabList className="mb-24" tabClassName="c-brand-night">
              <Tab>
                {t('practice.on_demand_practice.on_demand_practice_tab')}
              </Tab>
              {!isPreviewing && (
                <Tab disabled={tabState.disabled}>
                  {t('practice.on_demand_practice.previous_attempts_tab')}
                </Tab>
              )}
            </TabList>
            <TabPanel>
              <CurrentResponseTab
                scenarioId={scenarioId}
                ziggeoApiKey={data.ziggeoApiKey}
                currentUserId={data.currentUserId}
                setTabState={setTabState}
                hippoPreviewBase={data.hippoPreviewBase}
                isPreviewing={isPreviewing}
                hasZiggeoForAllMedia={hasZiggeoForAllMedia}
              />
            </TabPanel>
            <TabPanel>
              <PreviousAttemptsTab
                scenarioId={scenarioId}
                highlightFirstAttempt={tabState.highlightFirstAttempt}
                hasZiggeoForAllMedia={hasZiggeoForAllMedia}
                ziggeoApiKey={data.ziggeoApiKey}
              />
            </TabPanel>
          </TabbedView>
        </div>
      </div>
    </>
  );
};

export default props => <OnDemandPracticeScenario {...props} />;
